<po-info
  *ngIf="isCapped"
  p-label="Recorte"
  [p-value]="cappedNote"
  p-orientation="vertical">
</po-info>

<!-- Como ler uma coluna desta dimensão. Vive aqui, e não no card que abriu o modal,
     porque é da coluna que ele fala — e a coluna só existe nesta tabela: o card mostra
     barras de custo, onde não há execução nenhuma para comparar. Ver `readingNote`. -->
<po-info
  *ngIf="readingNote"
  p-label="Execuções"
  [p-value]="readingNote"
  p-orientation="vertical">
</po-info>

<!-- Exportação da própria tabela: leva o que está na tela (a busca aplicada
     inclusive), com os números crus para somar na planilha. É a contrapartida do CSV
     de execuções do painel — aquele detalha execução por execução, este entrega a
     visão já agregada.

     Acima da tabela, e não na barra de ações dela (busca + gerenciador de colunas):
     aquela barra é template interno do po-table, sem slot para um botão nosso. -->
<po-button
  *ngIf="hasRows"
  class="po-mb-1"
  p-label="Exportar CSV"
  p-kind="secondary"
  p-size="small"
  p-icon="po-icon-download"
  [p-disabled]="!canExport"
  (p-click)="exportCsv()">
</po-button>

<!-- p-hide-table-search=false: o padrão do po-table é esconder a busca. Faz sentido
     mostrar aqui — a tabela só existe dentro do modal "ver tabela completa", com até
     200 linhas, e não tinha como filtrar por review antes.

     SEM p-striped, de propósito: o zebrado do PO é `> tbody:nth-child(odd)`, ou seja,
     posição no DOM. Com `p-height` a tabela vira virtual scroll e só a janela renderizada
     (~24 linhas) está no DOM — a cada re-render do range as tbodies mudam de posição e a
     paridade inverte, então TODAS as faixas trocam de cor ao mesmo tempo. Na tela isso
     lê como a tabela piscando durante a rolagem. Sem o zebrado o po-table devolve o
     `border-bottom` das linhas (o próprio `.po-table-striped` é que o remove), que separa
     as linhas sem depender de índice. -->
<po-table
  *ngIf="hasRows; else emptyDimension"
  [p-columns]="columns"
  [p-items]="tableRows"
  [p-height]="height"
  [p-hide-table-search]="false"
  [p-hide-text-overflow]="true">

  <!-- Tipo em tag roxa, igual ao grid do Smart Review: é o mesmo objeto nas duas telas. -->
  <ng-template p-table-cell-template let-column="column" let-row="row">
    <ng-container *ngIf="column.property === 'resourceType'">
      <po-tag
        *ngIf="row.resourceType"
        [p-value]="row.resourceType"
        p-color="#753399"
        p-inverse="true">
      </po-tag>
    </ng-container>
  </ng-template>
</po-table>

<ng-template #emptyDimension>
  <p class="po-font-text-small">Sem dados neste período.</p>
</ng-template>
